import { GarageStatusContainer } from '../../containers/advancedFilters/GarageStatusContainer';
import { IFilter } from '../../types/advancedFilters';

export const garageStatus: IFilter = {
  component: GarageStatusContainer,
};
